//error messages
export const MISSING_PARAM_ERROR = "Missing values";
export const MISSING_WALLET_ERROR = "Missing wallet";
export const UNKNOWN_ERROR = "Something went wrong...";

export const WALLET_ERROR = "Wallet not connected";
export const LOADING_ERROR = "Unknown error. Please refresh the page and try again";
export const TX_FAILED_TO_CONFIRM = "Transaction failed to confirm";

//error types
export enum ErrorType {
    ResultError = "Result Error",
    ApiFetchError = "API Fetch Error",
    UnknownError = "Unknown Error",
    MissingParamsError = "Missing Params Error",
    DeserializationError = "Deserialization Error",
    ApiLoginError = "API Login Error",
    Web3UserError = "Web3 User Error",
    TransactionSendError = "Transaction send Error",
    AuthError = "Bearer Authorization Error"
}

export enum CustomContractErrors {
    INSUFFICIENT_COLLATERAL = 6001
}
